import marcaBlancaServices from 'legacyfrontend/api/services/marcaBlancaServices';
import { SET_SECTION_ERROR, SET_SECTION } from './action-types';

export const getCustomSection = (id) => async (dispatch) => {
  try {
    const response = await marcaBlancaServices.getCustomSection(id);
    return dispatch({
      type: SET_SECTION,
      payload: response,
    });
  } catch (error) {
    dispatch({ type: SET_SECTION_ERROR });
    throw error;
  }
};

export const getDefaultSection = (id) => async (dispatch) => {
  try {
    const response = await marcaBlancaServices.getDefaultSection(id);
    return dispatch({
      type: SET_SECTION,
      payload: response,
    });
  } catch (error) {
    dispatch({ type: SET_SECTION_ERROR });
    throw error;
  }
};
